/**
 * useWardrobe — equip state for the Character Customizer.
 * The economy is present in the UI but free for now: every item is owned, nothing
 * is locked, and coins are display-only (no debit). Wire real coins/ownership later.
 */

import { useCallback, useState } from 'react';
import { CATS, DEFAULT_FIT, INITIAL_COINS } from './characterCustomizer.constants';
import { normalizeEquipped, randomizeFit, toggleEquip } from './characterCustomizer.helper';
import type { CustomizerCategoryId, EquippedMap } from './characterCustomizer.types';

export interface Wardrobe {
  equipped: EquippedMap;
  equip: (cat: CustomizerCategoryId, id: string | null) => void;
  randomize: () => void;
  /** Display-only balance until the economy is wired. */
  coins: number;
}

export function useWardrobe(initial?: Partial<EquippedMap>): Wardrobe {
  const [equipped, setEquipped] = useState<EquippedMap>(() =>
    normalizeEquipped({ ...DEFAULT_FIT, ...initial })
  );

  const equip = useCallback((cat: CustomizerCategoryId, id: string | null) => {
    setEquipped((prev) => toggleEquip(prev, cat, id));
  }, []);

  const randomize = useCallback(() => {
    setEquipped(randomizeFit(CATS));
  }, []);

  return { equipped, equip, randomize, coins: INITIAL_COINS };
}
